import CaicDatePicker from './src/CaicDatePicker.vue'
const DatePicker = {
  install: function (Vue) {
    Vue.component(CaicDatePicker.name, CaicDatePicker)
  }
}
export default DatePicker



// WEBPACK FOOTER //
// ./src/date-picker/index.js